import React, { useState } from "react";
import { Link } from "react-router-dom";
import '../assests/CSS/navbar.css'; 
import logo from '../assests/images/logo.png';
import { FaBars, FaTimes, FaSearch, FaChevronDown, FaChevronUp } from "react-icons/fa";

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleMenu = () => setMenuOpen(!menuOpen);
    const closeMenu = () => setMenuOpen(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    return (
        <nav  className="navbar">
            
            <div className="mobile-header">
                <div className="hamburger" onClick={toggleMenu}>
                    {menuOpen ? <FaTimes className="hamburger-menu" /> : <FaBars className="hamburger-menu" />}
                </div>
                <Link to="/" className="logo" onClick={closeMenu}>
                    <img src={logo} alt="Thhiya" />
                </Link>
                <FaSearch className="icon search-icon" />
            </div>

           
            <div className={`nav-links ${menuOpen ? "mobile-menu active" : ""}`}>
                <Link to="/features" className="nav-link mobile-link" onClick={closeMenu}>Features</Link>
                
                
                <div className={`nav-link resources-dropdown ${menuOpen ? "mobile-link" : ""}`} onClick={toggleDropdown}>
                    Resources {dropdownOpen ? <FaChevronUp className="chevron-icon" /> : <FaChevronDown className="chevron-icon" />}
                    <div className={`dropdown-menu ${dropdownOpen ? "open" : ""}`}>
                        <Link to="/resources/Thhiyapedia" className="dropdown-item" onClick={closeMenu}>Thhiyapedia</Link>
                        <Link to="/resources/Blogs" className="dropdown-item" onClick={closeMenu}>Blogs</Link>
                        <Link to="/resources/Articles" className="dropdown-item" onClick={closeMenu}>Articles</Link>
                        {/* <Link to="/resources/E-Books" className="dropdown-item" onClick={closeMenu}>E-Books</Link> */}
                    </div>
                </div>

                {/* <Link to="/vendor-review" className="nav-link mobile-link" onClick={closeMenu}>Vendor Review</Link> */}
                <Link to="/gtm-toolkit" className="nav-link mobile-link" onClick={closeMenu}>GTM Toolkit</Link>
                <Link to="/about" className="nav-link mobile-link" onClick={closeMenu}>About Us</Link>

                {/*  mobile dropdown */}
                <div className="mobile-signin">
                    <button className="sign mobile-signup" onClick={closeMenu}>Signup</button>
                    <button className="sign mobile-login" onClick={closeMenu}>Login</button>
                </div>
            </div>

            {/* Desktop Signin Buttons */}
            <div className="signin desktop-signin">
                <button className="sign" id="signup">Signup</button>
                <button className="sign" id="login">Login</button>
            </div>
        </nav>
    );
};

export default Navbar;
